import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";


type OrgAppClientResponseType = ResponseType<null>;

function useRemoveClientMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<OrgAppClientResponseType>["response"],
    AxiosResponseAndError<OrgAppClientResponseType>["error"],
   string
  >({
    mutationFn: async (data) => {
      return ApiRequest.delete<OrgAppClientResponseType>(
        `${requestURLs.removeAppClient+data}`,
      );
    },
  });

  return mutation;
}

export default useRemoveClientMutation;
